'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index$1 = require('../../../../common/theme/index.js');
var Chip = require('../../../../common/components/Chip.js');
var Typography = require('../../../../common/components/Typography.js');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var index = require('../../../../common/components/Icon/index.js');
var Box = require('../../../../common/components/layout/Box/Box.js');
var ClaimStatusChip_module = require('./ClaimStatusChip.module.css.js');
var clsx = require('clsx');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

const ClaimStatusChip = _ref => {
  let {
    status
  } = _ref;
  const {
    claimsClaimDetailsClaimStatusPending,
    claimsClaimDetailsClaimStatusInReview,
    claimsClaimDetailsClaimStatusApproved,
    claimsClaimDetailsClaimStatusDenied,
    claimsClaimDetailsClaimStatusCanceled
  } = nthHookTranslations.useTranslations();
  const narvarStatusAttrs = {
    Canceled: {
      background: index$1.colors.statusIndeterminateLight,
      color: index$1.colors.statusIndeterminateDark,
      text: claimsClaimDetailsClaimStatusCanceled ?? ''
    },
    Approved: {
      background: index$1.colors.statusIndeterminateLight,
      color: index$1.colors.statusIndeterminateDark,
      text: claimsClaimDetailsClaimStatusApproved ?? ''
    },
    Denied: {
      background: index$1.colors.statusIndeterminateLight,
      color: index$1.colors.statusIndeterminateDark,
      text: claimsClaimDetailsClaimStatusDenied ?? ''
    },
    Created: {
      background: index$1.colors.statusInfoLight,
      color: index$1.colors.statusInfo,
      text: claimsClaimDetailsClaimStatusPending ?? '',
      icon: 'Clock'
    },
    Pending: {
      background: index$1.colors.statusInfoLight,
      color: index$1.colors.statusInfo,
      text: claimsClaimDetailsClaimStatusPending ?? '',
      icon: 'Clock'
    },
    InReview: {
      background: index$1.colors.statusInfo,
      color: index$1.colors.white,
      text: claimsClaimDetailsClaimStatusInReview ?? ''
    }
  };
  const {
    icon,
    color,
    text,
    background
  } = narvarStatusAttrs[status];
  const classes = clsx__default["default"]({
    [ClaimStatusChip_module["default"].chipContent]: !!icon
  });
  return /*#__PURE__*/React__default["default"].createElement(Chip["default"], {
    as: "div",
    style: {
      background: background,
      border: background,
      justifySelf: 'start'
    }
  }, /*#__PURE__*/React__default["default"].createElement(Typography.MetadataTextEmphasis, {
    style: {
      color
    }
  }, /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 1,
    className: classes
  }, icon && /*#__PURE__*/React__default["default"].createElement(index.IconThemed, {
    icon: icon,
    width: "1em",
    height: "1em"
  }), text)));
};
var ClaimStatusChip$1 = nthHookTranslations.withTranslationsProvider(ClaimStatusChip, {
  translationKeys: ['claimsClaimDetailsClaimStatusCreated', 'claimsClaimDetailsClaimStatusPending', 'claimsClaimDetailsClaimStatusInReview', 'claimsClaimDetailsClaimStatusApproved', 'claimsClaimDetailsClaimStatusDenied', 'claimsClaimDetailsClaimStatusCanceled']
});

exports["default"] = ClaimStatusChip$1;
